var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card-container" },
    _vm._l(_vm.list, function(item, idx) {
      return _c(
        "div",
        {
          class:
            "card " +
            (item.disabled ? " disabled" : "") +
            (item.active ? " active" : ""),
          on: {
            click: function($event) {
              return _vm.select(item.title)
            }
          }
        },
        [
          _c("img", { attrs: { src: item.icon } }),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(item.title))]),
          _vm._v(" "),
          _c("div", { staticClass: "detail" }, [_vm._v(_vm._s(item.detail))])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }